import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import { FlexBox } from '../layout';

export const ModalContainer = styled(Box)(({ theme }) => ({
  top: '50%',
  left: '50%',
  width: '560px',
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  gap: theme.spacing(3),
  padding: theme.spacing(8),
  borderRadius: theme.spacing(6),
  backgroundColor: theme.palette.background.default,
}));

export const ModalHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const ModalTitle = styled(Typography)({
  fontSize: '24px',
  fontWeight: 500,
  lineHeight: '120%',
});

export const ModalBody = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
}));

export const ModalButtonGroup = styled(FlexBox)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(2),
}));

export const IconBox = styled(Box)({
  lineHeight: 0,
});
